import React, { useState, useRef, useEffect } from "react";
import useUpdateVesselOtherDocuments from "../Utils/useUpdateVesselOtherDocuments";
import { ToastContainer, toast } from "react-toastify";
import { IoIosArrowDown } from "react-icons/io";
import { IoIosArrowUp } from "react-icons/io";
import { IoAddOutline } from "react-icons/io5";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { CiFileOn } from "react-icons/ci";
import { RiDeleteBin5Line } from "react-icons/ri";
import "react-toastify/dist/ReactToastify.css";
import "./updatevessel.css";

const UpdateVesselOtherDocumentsForm = ({ vesselId }) => {
  const { mutate, isLoading, isError, error } = useUpdateVesselOtherDocuments();
  const [formData, setFormData] = useState([]);
  const fileInputRef = useRef(null);
  const [collapsedSections, setCollapsedSections] = useState({ othervesselinof: true });

  useEffect(() => {
    if (isError) {
      toast.error(`An error occurred: ${error.message}`);
    }
  }, [isError, error]);

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    const newFormData = [...formData];
    newFormData[index] = {
      name: newFormData[index] ? newFormData[index].name : "",
      file: file,
    };
    setFormData(newFormData);
  };

  const handleNameChange = (e, index) => {
    const newName = e.target.value;
    const newFormData = [...formData];
    newFormData[index] = {
      name: newName,
      file: newFormData[index] ? newFormData[index].file : null,
    };
    setFormData(newFormData);
  };

  const addDocumentField = () => {
    setFormData([...formData, { name: "", file: null }]);
  };

  const removeDocument = (index) => {
    const newFormData = [...formData];
    newFormData.splice(index, 1);
    setFormData(newFormData);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validDocuments = formData.filter(item => item.name && item.file);

    if (validDocuments.length !== formData.length) {
      toast.error("Please provide a name and select a file for all documents.");
      return;
    }

    const documents = validDocuments.map(item => ({ name: item.name, file: item.file }));

    mutate(
      { vesselId, documents },
      {
        onSuccess: () => {
          toast.success("Documents uploaded successfully!");
        },
        onError: (error) => {
          toast.error(`Error updating vessel documents: ${error.message}`);
        },
      }
    );
  };

  const formatFileSize = (size) => {
    if (size >= 1000000) {
      return (size / 1000000).toFixed(2) + " MB";
    } else if (size >= 1000) {
      return (size / 1000).toFixed(2) + " KB";
    } else {
      return size + " bytes";
    }
  };

  const capitalizeInitial = (str) => {
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const toggleSection = (section) => {
    setCollapsedSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  return (
    <div className="update-vessel-container">
      <div className="pri" onClick={() => toggleSection("othervesselinof")}>
        <p>Vessel Other Document</p>
        {collapsedSections.othervesselinof ? (
          <IoIosArrowDown />
        ) : (
          <IoIosArrowUp />
        )}
      </div>
      {!collapsedSections.othervesselinof && (
        <form onSubmit={handleSubmit}>
          {formData.map((item, index) => (
            <div key={index} className="card">
              <input
                type="text"
                placeholder="Input name of document"
                value={item.name}
                onChange={(e) => handleNameChange(e, index)}
                 accept=".pdf"
              />
              {!item.file && (
                <>
                  <input
                    type="file"
                    ref={fileInputRef}
                    hidden
                    onChange={(e) => handleFileChange(e, index)}
                     accept=".pdf"
                  />
                  <img
                    src="https://i.ibb.co/MBfbwGm/Frame-1171277781.png"
                    alt="Upload"
                    onClick={() => fileInputRef.current.click()}
                    style={{ cursor: "pointer" }}
                  />
                </>
              )}
              {item.file && (
                <div className="uploaded">
                  <div className="wrap">
                    <CiFileOn className="file" />
                    <div className="in">
                      <span>
                        <h3>{capitalizeInitial(item.name)}</h3>
                        <p>{item.file.name}</p>
                      </span>
                      <p>{formatFileSize(item.file.size)} - 100% Uploaded</p>
                    </div>
                  </div>
                  <div className="last">
                    <IoCheckmarkDoneCircleOutline className="mark" />
                    <RiDeleteBin5Line
                      onClick={() => removeDocument(index)}
                      className="delete"
                    />
                  </div>
                </div>
              )}
            </div>
          ))}

          {formData.length <= 0 ? (
            <button type="button" onClick={addDocumentField} className="add">
              <IoAddOutline className="icon" />
              Add Document
            </button>
          ) : (
            <button type="button" onClick={addDocumentField} className="add">
              <IoAddOutline className="icon" />
              Add More Document
            </button>
          )}
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Uploading..." : "Submit"}
          </button>
        </form>
      )}
      <ToastContainer />
    </div>
  );
};

export default UpdateVesselOtherDocumentsForm;
